import React,{Component} from 'react'
import {connect} from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm } from 'semantic-ui-react'
import {setBannerStatus,getAllBanners,emptyBanner} from '../../Actions/BannerAction'


class SetBannerStatus extends Component{

    state={open:false}
    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })

    setBannerStatus (id,status)
    {
        this.props.setBannerStatus(id,status);
    }
    
    handleSubmit =(e)=>
    {
        const { id, status } = this.props;

        if (status === "SUSPENDED") {
            this.setBannerStatus(id, "ACTIVE");

        } else {

            this.setBannerStatus(id, "SUSPENDED");
        }
        this.close();
    }
    render ()
    {
        const {status_updated_successfully,error_updating_status} = this.props
        const {id,status} = this.props
        let contentPreview =null;
        if(status_updated_successfully===false)
        {
            alert("error setting status"+error_updating_status);
            this.props.emptyBanner();
        }
        else if (status_updated_successfully===true)
        {
            alert("banner updated successfully");
            this.props.emptyBanner();
            this.props.getAllBanners();
        }

        if (status==="SUSPENDED")
        {
            contentPreview=(
                <button className="seriesCardButtons" onClick={this.open}>
                        <FontAwesomeIcon icon="play" />
                </button>
            )
        }
        else {
            contentPreview = (
                <button className="seriesCardButtons" onClick={this.open}>||</button>
            )
        }

        return ( <span >
            {contentPreview}
            <Confirm id="modal" open={this.state.open} onCancel={this.close} onConfirm={this.handleSubmit} />
        </span>)

    }

}


const mapStateToProps =state =>
({
    status_updated_successfully:state.banners.status_updated_successfully,
    error_updating_status:state.banners.error_updating_status
})
export default connect (mapStateToProps,{setBannerStatus,getAllBanners,emptyBanner}) (SetBannerStatus)
